import React, { createContext, useContext, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../utils/cn';

const AccordionCtx = createContext(null);

export function Accordion({ type = 'single', defaultValue, value, onChange, children, className }) {
  const [internal, setInternal] = useState(defaultValue ?? (type === 'multiple' ? [] : null));
  const active = value !== undefined ? value : internal;

  const toggle = (key) => {
    if (type === 'multiple') {
      const next = active.includes(key) ? active.filter(k => k !== key) : [...active, key];
      setInternal(next);
      onChange?.(next);
    } else {
      const next = active === key ? null : key;
      setInternal(next);
      onChange?.(next);
    }
  };

  const isOpen = (key) => type === 'multiple' ? active.includes(key) : active === key;

  return (
    <AccordionCtx.Provider value={{ isOpen, toggle }}>
      <div className={cn('border border-border rounded-lg bg-surface divide-y divide-border', className)}>{children}</div>
    </AccordionCtx.Provider>
  );
}

function Item({ value, title, children }) {
  const { isOpen, toggle } = useContext(AccordionCtx);
  const open = isOpen(value);
  return (
    <div>
      <button
        type="button"
        onClick={() => toggle(value)}
        aria-expanded={open}
        className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-bg-2/40 transition-colors"
      >
        <ChevronDown className={cn('w-4 h-4 text-mute transition-transform duration-fast', open && 'rotate-180')} strokeWidth={2} />
        <span className="text-sm font-semibold">{title}</span>
      </button>
      {open && <div className="px-4 pb-4 pl-11 text-sm text-text-2 leading-relaxed">{children}</div>}
    </div>
  );
}

Accordion.Item = Item;
export default Accordion;
